import { WarningTable } from './WarningTable'
import { withWarningTable } from './withWarningTable'

const ConnectedWarningTable = withWarningTable(WarningTable)

export { ConnectedWarningTable as WarningTable }
